export const WhatsAppActionTypes = {
  GET_QR_BASE64_REQUEST: 'GET_QR_BASE64_REQUEST',
  GET_QR_BASE64_SUCCESS: 'GET_QR_BASE64_SUCCESS',
  GET_QR_BASE64_FAILURE: 'GET_QR_BASE64_FAILURE',

  LIST_INSTANCES_REQUEST: 'LIST_INSTANCES_REQUEST',
  LIST_INSTANCES_SUCCESS: 'LIST_INSTANCES_SUCCESS',
  LIST_INSTANCES_FAILURE: 'LIST_INSTANCES_FAILURE',

  EDIT_INSTANCE_REQUEST: 'EDIT_INSTANCE_REQUEST',
  EDIT_INSTANCE_SUCCESS: 'EDIT_INSTANCE_SUCCESS',
  EDIT_INSTANCE_FAILURE: 'EDIT_INSTANCE_FAILURE',

  GET_WHATSAPP_CHATS_REQUEST: 'GET_WHATSAPP_CHATS_REQUEST',
  GET_WHATSAPP_CHATS_SUCCESS: 'GET_WHATSAPP_CHATS_SUCCESS',
  GET_WHATSAPP_CHATS_FAILURE: 'GET_WHATSAPP_CHATS_FAILURE',

  GET_WHATSAPP_CHAT_MESSAGES_REQUEST: 'GET_WHATSAPP_CHAT_MESSAGES_REQUEST',
  GET_WHATSAPP_CHAT_MESSAGES_SUCCESS: 'GET_WHATSAPP_CHAT_MESSAGES_SUCCESS',
  GET_WHATSAPP_CHAT_MESSAGES_FAILURE: 'GET_WHATSAPP_CHAT_MESSAGES_FAILURE',

  APPEND_WHATSAPP_CHAT_MESSAGES: 'APPEND_WHATSAPP_CHAT_MESSAGES',

  SET_WHATSAPP_PAGE_INFO: 'SET_WHATSAPP_PAGE_INFO',

  SET_LOADING_SCREEN: 'SET_LOADING_SCREEN',
};